import {useEffect, useRef, useState} from "react";
import ChurchesBlock from "./churchs-block";

export default function ChurchesInfiniteBlock({churchData, hasMore, actions}) {
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const sentinelRef = useRef(null);

    useEffect(() => {
        if (!sentinelRef.current || !actions?.onLoadMore || !hasMore) return;

        let scrollableContainer = null;
        let element = sentinelRef.current.parentElement;
        while (element) {
            const overflow = window.getComputedStyle(element).overflowY;
            if (overflow === "auto" || overflow === "scroll") {
                scrollableContainer = element;
                break;
            }
            element = element.parentElement;
        }

        const obs = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting || isLoadingMore) return;

                setIsLoadingMore(true);
                Promise.resolve(actions.onLoadMore()).finally(() => setIsLoadingMore(false));
            });
        }, {root: scrollableContainer, rootMargin: "100px", threshold: 0.01});

        obs.observe(sentinelRef.current);

        return () => obs.disconnect();
    }, [actions, hasMore, isLoadingMore]);

    return (
        <>
            <ChurchesBlock churchData={churchData} isPagination={false}/>
            <div ref={sentinelRef}/>
            {isLoadingMore && (
                <div className="flex justify-center p-4">
                    <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-gray-900"></div>
                </div>
            )}
            {!hasMore && (churchData.value?.length ?? 0) > 0 && !isLoadingMore && (
                <div className="flex justify-center p-4 text-sm text-gray-500 italic">
                    Đã hiển thị tất cả kết quả phù hợp
                </div>
            )}
        </>
    );
}
